"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.ragStatus.pending': 'Pendiente',
    'knowledge.ragStatus.processing': 'Procesando',
    'knowledge.ragStatus.completed': 'Completado',
    'knowledge.ragStatus.failed': 'Falló',
    'knowledge.ragStatus.not_indexed': 'No aplica',
    'knowledge.ragStatus.disabled': 'Deshabilitado',
};
